import { render, staticRenderFns } from "./z-button.vue?vue&type=template&id=3f2cc403&scoped=true"
import script from "./z-button.vue?vue&type=script&lang=ts"
export * from "./z-button.vue?vue&type=script&lang=ts"
import style0 from "./z-button.vue?vue&type=style&index=0&id=3f2cc403&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2cc403",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2cc403')) {
      api.createRecord('3f2cc403', component.options)
    } else {
      api.reload('3f2cc403', component.options)
    }
    module.hot.accept("./z-button.vue?vue&type=template&id=3f2cc403&scoped=true", function () {
      api.rerender('3f2cc403', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/z-button.vue"
export default component.exports